import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SlideContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1rem;
  padding-top: 4.5rem;
  max-width: 1200px;
  margin: 0 auto;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: 0.8rem;
    padding-top: 4rem;
  }

  @media (max-width: 480px) {
    padding: 0.5rem;
    padding-top: 3.5rem;
  }
`;

const SlideTitle = styled(motion.h2)`
  font-size: 3.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(45deg, #6F1A3F, #C82B3F);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 1024px) {
    font-size: 3rem;
  }

  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  width: 100%;
`;

const ProjectCard = styled(motion.div)`
  background: rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(111, 26, 63, 0.3);
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    border-color: rgba(200, 43, 63, 0.6);
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(111, 26, 63, 0.2);
  }
`;

const ProjectImage = styled.div`
  height: 150px;
  background: linear-gradient(135deg, rgba(111, 26, 63, 0.3), rgba(200, 43, 63, 0.3));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transform: translateX(-100%);
    transition: transform 0.6s ease;
  }

  ${ProjectCard}:hover &::before {
    transform: translateX(100%);
  }
`;

const ProjectContent = styled.div`
  padding: 1.5rem;
`;

const ProjectTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.8rem;
`;

const ProjectDescription = styled.p`
  color: #ccc;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-size: 0.9rem;
`;

const ProjectTech = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-bottom: 1rem;
`;

const TechTag = styled.span`
  background: rgba(111, 26, 63, 0.2);
  color: #C82B3F;
  padding: 0.2rem 0.6rem;
  border-radius: 15px;
  font-size: 0.7rem;
  font-weight: 500;
  border: 1px solid rgba(111, 26, 63, 0.3);
`;


const Slide6 = () => {
  const techProjects = [
    {
      title: 'Quest and Treats (AR Gamification)',
      description: 'Gamified Augmented Reality quest system for customer engagement and foot traffic solutions with in-store quest solving and reward system.',
      tech: ['AR', 'Gamification', 'Reward Engine'],
      icon: '🎮'
    },
    {
      title: 'Qudah Labs (QCL) Platform',
      description: 'Specialized laboratory services platform with enhanced user access and streamlined solutions for laboratory management.',
      tech: ['Web Development', 'Platform', 'User Management'],
      icon: '🧪'
    },
    {
      title: 'RSS Jordan Cybersecurity Initiative',
      description: 'National security project involving penetration testing for 100+ governmental services with comprehensive vulnerability assessments.',
      tech: ['Cybersecurity', 'Penetration Testing', 'Government'],
      icon: '🛡️'
    },
    {
      title: 'Dr Ahmad Al-khaldi & Al Itqan Center',
      description: 'Healthcare digital solutions with patient engagement and service optimization for medical practices.',
      tech: ['Healthcare', 'Patient Management', 'Digital Solutions'],
      icon: '🏥'
    }
  ];

  return (
    <SlideContainer>
      <SlideTitle
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Technology Projects
      </SlideTitle>

      <ProjectsGrid>
        {techProjects.map((project, index) => (
          <ProjectCard
            key={index}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: index * 0.1 }}
            whileHover={{ scale: 1.02 }}
          >
            <ProjectImage>
              {project.icon}
            </ProjectImage>
            <ProjectContent>
              <ProjectTitle>{project.title}</ProjectTitle>
              <ProjectDescription>{project.description}</ProjectDescription>
              <ProjectTech>
                {project.tech.map((tech, techIndex) => (
                  <TechTag key={techIndex}>{tech}</TechTag>
                ))}
              </ProjectTech>
            </ProjectContent>
          </ProjectCard>
        ))}
      </ProjectsGrid>
    </SlideContainer>
  );
};

export default Slide6;